import { useNavigate } from 'react-router-dom';
import { WelcomeStep } from '../../components/Onboarding/WelcomeStep';
import bg from '../../assets/bg-register.jpg';

export const OnboardingPage = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/chat-onboarding');
  };

  return (
    <div 
      className="h-screen bg-cover bg-center bg-no-repeat flex flex-col items-center justify-center px-3 sm:px-4 py-4 sm:py-6"
      style={{ backgroundImage: `url(${bg})` }}
    >
      {/* Contenedor del contenido de onboarding */}
      <div className="w-full max-w-sm sm:max-w-md space-y-4 sm:space-y-6 flex flex-col justify-center">
        {/* Contenedor del paso de bienvenida */}
        <WelcomeStep onNext={handleGetStarted} />
      </div>
    </div>
  );
};